import React from 'react';

import { MapStyled, Marker } from './styled';

import MapImage from 'src/images/map.png';

import clsx from 'clsx';
import healthList from 'src/apis/samples/health';

interface MapProps {
  onMarkerClick: (marker: any) => void;
}

const Map = ({ onMarkerClick }: MapProps) => {
  const [touchState, setTouchState] = React.useState({
    touching: false,
    startX: 0,
    startY: 0,
  });
  const [mapOffsetState, setMapOffsetState] = React.useState({
    x: 0,
    y: 0,
    moveX: 0,
    moveY: 0,
  });
  return (
    <MapStyled
      className={clsx('Map')}
      onTouchStart={e => {
        setTouchState({
          ...touchState,
          touching: true,
          startX: e.touches[0].clientX,
          startY: e.touches[0].clientY,
        });
      }}
      onTouchMove={e => {
        if (!touchState.touching) return;
        setMapOffsetState({
          ...mapOffsetState,
          moveX: mapOffsetState.x + (e.touches[0].clientX - touchState.startX),
          moveY: mapOffsetState.y + (e.touches[0].clientY - touchState.startY),
        });
      }}
      onTouchEnd={e => {
        setTouchState({
          ...touchState,
          touching: false,
        });
        setMapOffsetState({
          ...mapOffsetState,
          x: mapOffsetState.moveX,
          y: mapOffsetState.moveY,
        });
      }}
    >
      <div className="image-wrapper">
        <img
          src={MapImage}
          alt="맵 이미지"
          style={{
            width: '100%',
          }}
        />
        {healthList.map(health => (
          <Marker
            key={health.id}
            left={health.x}
            top={health.y}
            background={health.color}
            onClick={() => {
              onMarkerClick(health.id);
            }}
          />
        ))}
      </div>
    </MapStyled>
  );
};

export default Map;
